import classNames from 'classnames';

export const Right = ({ children, className, ...r }) => {
  const classnames = classNames('right-options', className);

  return (
    <div className={classnames} {...r}>
      {children}
    </div>
  );
};
